import LinkButton from '@root/joinroot.com/src/components/buttons/link-button';
import LinkButtonModel from '@root/joinroot.com/src/models/link-button';
import PropTypes from '@root/vendor/prop-types';
import { H2 } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function ExpandableGroup({
  anchor,
  groupTitle,
  groupStyles,
  children,
  link,
}) {
  return (
    <div
      css={[styles.container, styles.anchorSpacer, groupStyles]}
      id={anchor}
    >
      <H2 css={styles.title}>{groupTitle}</H2>
      <div css={styles.content}>
        {children}
        {link &&
          <LinkButton
            to={link.to}
            type={LinkButtonModel.types.TERTIARY}
          >
            {link.text}
          </LinkButton>
        }
      </div>
    </div>
  );
}

ExpandableGroup.propTypes = {
  anchor: PropTypes.string,
  children: PropTypes.node.isRequired,
  groupStyles: PropTypes.object,
  groupTitle: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  }),
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 800,
  },
  anchorSpacer: {
    '&:before': {
      display: 'block',
      content: '" "',
      marginTop: -110,
      height: 110,
      visibility: 'hidden',
      pointerEvents: 'none',
    },
  },
  title: {
    marginBottom: 10,
  },
  content: {
    '& > *:last-child': {
      border: 'none',
    },
    '& > a': {
      height: 70,
      padding: '0 10px',
      alignItems: 'center',
    },
  },
});
